import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import FeedItem from './FeedItem';
import RSSAPI from '../../api/RSSAPI';

const RSSFeed: React.FC = () => {
  const [ feedItems, setFeedItems ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ combinedItems, setCombinedItems ] = useState<any[]>([]);

  const getRSSFeed = async() => {
    const resp = await RSSAPI.getRSSFeed();
    if (resp?.success) {
      return resp;
    }
    setFeedItems({ isLoading: false, data: [] });
  };

  const combineFeeds = (data: any) => {
    const combinedData = [];
    // eslint-disable-next-line guard-for-in
    for (const prop in data) {
      combinedData.push(data[prop][0].items);
    }
    // sort by date
    return combinedData.flat().sort((a, b) => {
      const d1 = new Date(a.pubDate);
      const d2 = new Date(b.pubDate);
      return d2.getTime() - d1.getTime();
    });
  };

  useEffect(() => {
    getRSSFeed().then((resp: any) => {
      setFeedItems({ isLoading: false, data: resp?.result });
      setCombinedItems(combineFeeds(resp?.result));
    });
  }, []);

  return (
    <div>
      <section className='home-content-body HeaderDown-RSS'>
        <Grid container>
          {feedItems.isLoading ? (
            <div>
              <CircularProgress style={{ color: '#4895EF' }} />
            </div>
          ) : (
            <div className='Dashboard-container-RSS feed-container'>
              {combinedItems?.map((feedItem: any, i: number) => (
                <FeedItem
                  key={i}
                  title={feedItem.title}
                  link={feedItem.link}
                  date={feedItem.pubDate}
                  content={feedItem.contentSnippet}
                />
              ))}
            </div>
          )}
        </Grid>
      </section>
    </div>
  );
};

export default RSSFeed;
